import { useCallback, useEffect, useState } from 'react';
// Direct import (not via the `common/hooks` barrel) avoids dragging the rest
// of the hooks barrel - and through it, the `services/hooks` barrel and most
// of the app graph - into anything that uses `useCurrencies`. Pure re-exports
// in the barrel mean this is a behaviorally identical change.
import useUsedCurrencies from 'common/hooks/useUsedCurrencies';
import { worldCurrencies } from 'utilities';

export const useCurrencies = () => {
  const usedCurrencies = useUsedCurrencies();
  const [currencies, setCurrencies] = useState<{ code: string; symbol: string }[]>([]);

  const setInitialCurrencies = useCallback(() => {
    const tmpCurrencies = [...new Set(usedCurrencies)];
    setCurrencies(tmpCurrencies.map(code => ({ code, symbol: worldCurrencies[code] })));
  }, [usedCurrencies]);

  useEffect(() => {
    if (usedCurrencies) {
      setInitialCurrencies();
    }
  }, [setInitialCurrencies, usedCurrencies]);

  const showMore = () => {
    const tmpCurrencies = [...new Set([...usedCurrencies, ...Object.keys(worldCurrencies)])];
    setCurrencies(tmpCurrencies.map(code => ({ code, symbol: worldCurrencies[code as keyof typeof worldCurrencies] })));
  };

  const showLess = () => {
    setInitialCurrencies();
  };

  return {
    usedCurrencies, currencies, setCurrencies, showMore, showLess
  }
}